<template>
    <div class="counter">
        {{ formattedTime }}
    </div>
</template>

<script>
export default {
    name: 'Counter',
    props: {
        initialSeconds: {
            type: Number,
            default: 60,
        },
        format: {
            type: String,
            default: 'mm:ss',
            validator: (value) => ['seconds', 'mm:ss'].includes(value),
        },
    },
    data() {
        return {
            currentSeconds: this.initialSeconds,
            timerInterval: null,
        };
    },
    computed: {
        formattedTime() {
            if (this.format === 'seconds') {
                return `${this.currentSeconds} с`;
            }
            // ✅ Убрали `else`
            const minutes = Math.floor(this.currentSeconds / 60);
            const seconds = this.currentSeconds % 60;
            return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
        },
    },
    mounted() {
        this.start();
    },
    methods: {
        start() {
            if (this.timerInterval) {
                return; // уже запущен
            }

            this.timerInterval = setInterval(() => {
                if (this.currentSeconds > 0) {
                    this.currentSeconds -= 1;
                } else {
                    this.stop();
                }
            }, 1000);

            this.$emit('start');
        },
        stop() {
            if (this.timerInterval) {
                clearInterval(this.timerInterval);
                this.timerInterval = null;
                this.$emit('stop');
            }
        },
    },
    beforeUnmount() {
        this.stop(); // очищаем интервал при размонтировании
    },
};
</script>

<style scoped>
.counter {
    font-family: monospace;
    font-size: 16px;
    color: #333;
}
</style>
